import * as React from "react";

import { AppPreviewGalleryInternalProps } from "@1js/acui-gallery";
import {
  AppFontStylesGalleryButtonProps,
  AppFontStylesPreviewGallery,
  AppFontStylesPreviewGalleryProps,
} from "@1js/acui-gallery-font-styles";

import { RibbonControlInternalProps } from "../../RibbonControlProps";

export type RibbonFontStylesPreviewGalleryInternalProps =
  AppFontStylesPreviewGalleryProps &
    AppPreviewGalleryInternalProps<AppFontStylesGalleryButtonProps> &
    RibbonControlInternalProps;

export class RibbonFontStylesPreviewGallery extends React.PureComponent<
  RibbonFontStylesPreviewGalleryInternalProps,
  {}
> {
  public render() {
    return <AppFontStylesPreviewGallery {...this.props} persistMenu={true} />;
  }
}
